import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters, TSelectFilterOption } from '../../../models'

const setBrands = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
    brands: TSelectFilterOption[]
  }>
) => {
  const selectedFilters = state.find((item) => item.id === action.payload.id)

  if (!selectedFilters) {
    const newState = {
      id: action.payload.id,
      filters: {
        brands: action.payload.brands,
      },
    }
    state.push(newState)
  } else {
    selectedFilters.filters.brands = action.payload.brands
  }
}

export default setBrands
